// @flow
import createAction from '../../../../../util/createAction';

export const SET_QUERY = 'marketplace/search/set-query';

export const setQuery = createAction(SET_QUERY);
